// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","loader__message":"Loader_loader__message__MpiPx","loader__spinner":"Loader_loader__spinner__QoLfC"};